var _defs, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUspSilencer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "95px",
    height: "40px",
    viewBox: "0.521 0 95 40",
    enableBackground: "new 0.521 0 95 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.463,5.74l-0.337-1.179l-0.281-0.337H72.61l-0.394,0.169l-0.394-0.057H58.407l-0.505-0.225l-0.395,0.225H51.67v1.628 h-1.685v0.786h-1.123V5.853L48.47,5.348l-0.394,0.056v-1.01L47.74,4h-2.808v1.517H33.144v0.168h-6.849V5.46H14.056l-0.338-0.281 l-3.592-0.056L9.227,4.617v0.955L8.049,7.817l-0.729,3.649L5.635,10.4l-0.281,1.46l-0.618-0.057c-0.411,0-0.655,0.188-0.729,0.562 c-0.038,0.3,0.075,0.542,0.336,0.729l0.393,0.112l2.078,0.225L6.7,14.273l-0.055,1.292l0.448,0.449l1.46,0.505 c0.749,0.262,1.234,0.506,1.46,0.729c0.3,0.263,0.394,0.618,0.281,1.067l-0.394,1.01l-0.786,1.629 c-0.825,1.796-1.497,3.723-2.021,5.782c-0.485,2.021-0.842,4.154-1.066,6.4l-0.112,2.75L17.985,36l-0.618-0.897l0.113-1.348 l2.862-12.126l0.393,0.111l1.011-0.111l0.843-0.169l0.842,0.112l1.461,0.447l0.842,0.338l5.838-0.224l0.898-0.169l0.562-0.617 l2.246-5.502c0.111-0.263,0.261-0.468,0.448-0.617l0.225-0.112h12.744l0.111-1.909l0.281-0.225v-0.954l-0.281-0.225V9.839h1.18 v0.843h1.908v1.01h5.672l0.504,0.169l0.337-0.226h13.417l0.338-0.111l0.224,0.168h17.46l0.225-0.505l0.337-1.179l0.169-2.19 L90.463,5.74z M33.817,16.521l-0.842,2.358l-1.123,2.526l-2.47,0.168l-2.75-0.113l-1.236-0.112l-1.628-0.056l-1.46-0.619 l-0.953-1.123c-0.227-0.487-0.264-1.01-0.113-1.571c0.111-0.524,0.373-1.011,0.785-1.46c0.301-0.3,0.786-0.562,1.46-0.786 l0.897-0.225l-0.616,0.729c-0.488,0.637-0.769,1.329-0.842,2.078c-0.038,0.448,0.092,1.01,0.394,1.684l0.448,0.955l0.394-0.281 l-0.225-0.562l-0.114-1.122c0.037-0.525,0.188-0.992,0.449-1.404l0.674-0.898l1.349-1.403l6.399-0.056l0.393,0.058l0.619,0.338 l0.111,0.561V16.521z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "sliceCopy_x5F_30_1_",
    x: 94.576,
    fill: "none",
    width: 63.669,
    height: 40
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "sliceCopy_x5F_29_1_",
    fill: "none",
    width: 94.576,
    height: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUspSilencer);
export default __webpack_public_path__ + "static/media/usp_silencer.539d4646e737152e48059e360638008b.svg";
export { ForwardRef as ReactComponent };